export const LOCAL_STORAGE_KEYS = {
  getUserPostMessageConfirmationKey: (userUid: string) =>
    `postMessageConfirmationRequired_${userUid}`,
} as const
